import React from 'react';

import { Box, Grid } from '@mui/material';
import { FieldValues } from 'react-hook-form';
import { makeStyles } from 'tss-react/mui';

import { OhsFormSettings } from 'global-components/form/services/OhsFormModels';
import { useAppSelector } from 'app/hooks';
import OhsSelectField from 'global-components/form/fields/OhsSelectField';
import OhsMultipleSelectField from 'global-components/form/fields/OhsMultipleSelectField';
import {
  Status,
  exchangeMappedStatus,
} from 'correspondence/models/OhsCorrespondenceExchangeRecord';

import { getGlobalFilter } from '../OhsTopFilterSlice';
import { OhsFilterList } from '../OhsFilterModels';

const useStyles = makeStyles()(() => ({
  root: {
    flexGrow: 1,
  },
  fieldWrap: {
    margin: '10px 0 10px 0',
  },
  filterContent: {
    width: '100%',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
interface Props {
  ohsFormSettings: OhsFormSettings<FieldValues>;
}

const statuses: Status[] = ['INCOMPLETE', 'READY_TO_SEND', 'SENT', 'VIEWED', 'CLOSED'];

function OhsCorrespondenceExchangeFilters(props: Props) {
  const { classes } = useStyles();
  const filter = useAppSelector(getGlobalFilter) as OhsFilterList;
  const statusOptions = statuses.map((item) => ({ name: exchangeMappedStatus[item], value: item }));

  return (
    <Box className={classes.filterContent}>
      <Grid item md={12} xs={12} className={classes.fieldWrap}>
        <OhsSelectField
          title="Sort By"
          id="correspondenceExchangeModule.sort"
          required
          options={filter.correspondenceExchangeModule.tableSortKeyLists?.sortColAscDescOptions}
          ohsFormSettings={props.ohsFormSettings}
        />
      </Grid>
      <Grid item md={12} xs={12} className={classes.fieldWrap}>
        <OhsMultipleSelectField
          title="Status"
          id="correspondenceExchangeModule.status"
          required={false}
          options={statusOptions}
          ohsFormSettings={props.ohsFormSettings}
        />
      </Grid>
    </Box>
  );
}

export default OhsCorrespondenceExchangeFilters;
